import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type SPTableDataExportLoc = 'SPTableDataExportTooltip';

export const spTableDataExportLocs: LocDefs<SPTableDataExportLoc> = {
	SPTableDataExportTooltip: {
		defaultValue: 'Download to CSV',
		description: 'Assistive text displayed for the export button',
		displayPath: 'Data View|Data Export',
		displayType: 'Content',
		shared: true,
		portal: 'SP',
		feature: HubFeature.Core,
	},
};

export const LOC_KEYS = MapLocKeys<SPTableDataExportLoc>(spTableDataExportLocs);
export type SPTableDataExportLocType = LocMap<SPTableDataExportLoc>;
